<template>
  <svg :width="width" :height="height" viewBox="0 0 26 26" fill xmlns="http://www.w3.org/2000/svg">
    <g :fill="color">
      <path d="M13 26C5.8319 26 0 20.1681 0 13C0 5.83195 5.8319 0 13 0C20.1682 0 26.0001 5.8319 26.0001 13C26.0001 20.1682 20.1681 26 13 26ZM13 1.62501C6.72777 1.62501 1.62501 6.72771 1.62501 13C1.62501 19.2723 6.72771 24.375 13 24.375C19.2723 24.375 24.375 19.2723 24.375 13C24.375 6.72771 19.2723 1.62501 13 1.62501Z" />
      <path d="M9.80222 19.2036L14.6755 6.20821L16.197 6.77878L11.3237 19.7742L9.80222 19.2036Z" />
      <path d="M9.15632 13.2735C7.81221 13.2735 6.7188 12.1801 6.7188 10.8359C6.7188 9.49184 7.81221 8.39844 9.15632 8.39844C10.5004 8.39844 11.5938 9.49184 11.5938 10.8359C11.5938 12.1801 10.5004 13.2735 9.15632 13.2735ZM9.15632 10.0234C8.70802 10.0234 8.34381 10.3877 8.34381 10.8359C8.34381 11.2842 8.70802 11.6485 9.15632 11.6485C9.60461 11.6485 9.96882 11.2842 9.96882 10.8359C9.96882 10.3877 9.60461 10.0234 9.15632 10.0234Z" />
      <path d="M17.5548 18.3127C16.2107 18.3127 15.1173 17.2192 15.1173 15.8751C15.1173 14.531 16.2107 13.4376 17.5548 13.4376C18.8989 13.4376 19.9923 14.531 19.9923 15.8751C19.9923 17.2192 18.8989 18.3127 17.5548 18.3127ZM17.5548 15.0626C17.1065 15.0626 16.7423 15.4268 16.7423 15.8751C16.7423 16.3234 17.1065 16.6876 17.5548 16.6876C18.0031 16.6876 18.3673 16.3234 18.3673 15.8751C18.3673 15.4268 18.0031 15.0626 17.5548 15.0626Z" />
    </g>
  </svg>
</template>

<script>
export default {
  props: {
    width: { type: String },
    height: { type: String },
    color: { type: String }
  }
}
</script>
